import { Check } from "lucide-react";

export function OptionCard({ selected, onClick, testId, title, subtitle, price, className = "" }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      aria-pressed={selected}
      className={`flex w-full items-start justify-between gap-4 rounded-2xl border p-5 text-left transition-all duration-300 ${
        selected ? "border-blue bg-blue text-canvas" : "border-subtle bg-canvas hover:border-sage"
      } ${className}`}
    >
      <span>
        <span className="block font-sans font-semibold">{title}</span>
        {subtitle && (
          <span className={`mt-1 block text-xs leading-relaxed ${selected ? "text-canvas/75" : "text-faint"}`}>{subtitle}</span>
        )}
      </span>
      <span className="flex shrink-0 items-center gap-2">
        {price && <span className={`font-serif text-xl ${selected ? "text-canvas" : "text-blue"}`}>{price}</span>}
        {selected && <Check size={16} />}
      </span>
    </button>
  );
}

export function StepHeading({ title, hint }) {
  return (
    <div>
      <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-ink">{title}</h2>
      {hint && <p className="mt-2 text-sm leading-relaxed text-faint">{hint}</p>}
    </div>
  );
}
